module.exports = __webpack_public_path__ + "img/delivery.e8a3f1de.png";